import { fetchRooms } from "../services/rooms"
const result = {
    deluxeHarbourSuite:{
            title: {
                en:'Deluxe Harbour View Suite',
                tc:'豪華維港景套房',
                sc:'豪华維港景套房',
            },
            text:{
                en:'offers breathtaking ocean views, luxurious amenities, and spacious living areas, providing an unforgettable experience for those seeking relaxation and comfort by the sea.',
                tc:'提供令人驚嘆的維港景、豪華的設施和寬敞的起居區，為那些尋求海邊放鬆和舒適的人們提供難忘的體驗。',
                sc:'提供令人惊叹的維港景、豪华的设施和宽敞的起居区，为那些寻求海边放松和舒适的人们提供难忘的体验。',
            },
            hoverText:{
                en:'offers breathtaking ocean views, luxurious amenities, and spacious living areas, providing an unforgettable experience for those seeking relaxation and comfort by the sea.',
                tc:'提供令人驚嘆的維港景、豪華的設施和寬敞的起居區，為那些尋求海邊放鬆和舒適的人們提供難忘的體驗。',
                sc:'提供令人惊叹的維港景、豪华的设施和宽敞的起居区，为那些寻求海边放松和舒适的人们提供难忘的体验。',
            },
            capacity:{
                en:'1-2 person',
                tc:'1-2人',
                sc:'1-2人',
            },
            room:{
                en:'35㎡~ | Floor 31-36',
                tc:'35平方米~ | 層數 31-36',
                sc:'35平方米~ | 层数 31-36',
            },
            bed:{
                en:'1 Queen bed',
                tc:'1張大床',
                sc:'1张大床',
            },
            des:{
                en:'Fixed window',
                tc:'固定窗戶',
                sc:'固定窗户',
            },
            homeImg:'./images/home/sec3_2.png',
            img:['./images/rooms/row1_0.png','./images/rooms/row1_0.png'],
            view: {
                en:'harbour view',
                tc:'harbour view',
                sc:'harbour view',
            },
            amenities:{
                en:'Soap/Bathtub or Shower/Slippers Private Bathroom/Private Toilet/Hair Dryer/Bath Towel',
                tc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人廁所/吹風機/浴巾',
                sc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人厕所/吹风机/浴巾',
            },
            priceNum:1100,
            bookingImg:'./images/rooms/row1_0.png',
            seaView:'Upper Floor Seaview',
    },
    deluxeHarbourRoom:{
            title: {
                en:'Deluxe Harbour View Room',
                tc:'豪華維港景客房',
                sc:'豪华維港景客房',
            },
            text:{
                en:'combines modern comfort with premium amenities, offering spacious living areas and personalized services, ideal for both short and long-term stays. Enjoy a home-like atmosphere..',
                tc:'結合了現代舒適設施和高級設施，提供寬敞的起居區和個人化服務，是短期和長期住宿的理想選擇。享受如家般的氛圍。',
                sc:'结合了现代舒适设施和高级设施，提供宽敞的起居区和个人化服务，是短期和长期住宿的理想选择。享受如家般的氛围。',
            },
            hoverText:{
                en:'combines modern comfort with premium amenities, offering spacious living areas and personalized services, ideal for both short and long-term stays. Enjoy a home-like atmosphere..',
                tc:'結合了現代舒適設施和高級設施，提供寬敞的起居區和個人化服務，是短期和長期住宿的理想選擇。享受如家般的氛圍。',
                sc:'结合了现代舒适设施和高级设施，提供宽敞的起居区和个人化服务，是短期和长期住宿的理想选择。享受如家般的氛围。',
            },
            capacity:{
                en:'1-2 person',
                tc:'1-2人',
                sc:'1-2人',
            },
            room:{
                en:'35㎡~ | Floor 29-30',
                tc:'35平方米~ | 層數 29-30',
                sc:'35平方米~ | 层数 29-30',
            },
            bed:{
                en:'1 Queen bed',
                tc:'1張大床',
                sc:'1张大床',
            },
            des:{
                en:'Fixed window',
                tc:'固定窗戶',
                sc:'固定窗户',
            },
            
            img:['./images/rooms/row2_0.png','./images/rooms/row2_0.png'],
            view: {
                en:'harbour view',
                tc:'harbour view',
                sc:'harbour view',
            },
            amenities:{
                en:'Soap/Bathtub or Shower/Slippers Private Bathroom/Private Toilet/Hair Dryer/Bath Towel',
                tc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人廁所/吹風機/浴巾',
                sc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人厕所/吹风机/浴巾',
            },
            priceNum:990,
            bookingImg:'./images/rooms/row2_0.png',
            seaView:'Upper Floor Seaview',
    },
    deluxeRoom:{
            title: {
                en:'Deluxe Room',
                tc:'豪華客房',
                sc:'豪华客房',
            },
            text:{
                en:'provide a blend of home comforts and hotel services, featuring spacious accommodations and convenient amenities, perfect for both short and long stays. Enjoy a welcoming atmosphere.',
                tc:'提供家庭舒適和飯店服務的融合，擁有寬敞的住宿和便利的設施，非常適合短期和長期住宿。享受熱情的氛圍。',
                sc:'提供家庭舒适和饭店服务的融合，拥有宽敞的住宿和便利的设施，非常适合短期和长期住宿。享受热情的氛围。',
            },
            hoverText:{
                en:'provide a blend of home comforts and hotel services, featuring spacious accommodations and convenient amenities, perfect for both short and long stays. Enjoy a welcoming atmosphere.',
                tc:'提供家庭舒適和飯店服務的融合，擁有寬敞的住宿和便利的設施，非常適合短期和長期住宿。享受熱情的氛圍。',
                sc:'提供家庭舒适和饭店服务的融合，拥有宽敞的住宿和便利的设施，非常适合短期和长期住宿。享受热情的氛围。',
            },
            capacity:{
                en:'1-2 person',
                tc:'1-2人',
                sc:'1-2人',
            },
            room:{
                en:'35㎡~ | Floor 29-30',
                tc:'35平方米~ | 層數 21-28',
                sc:'35平方米~ | 层数 21-28',
            },
            bed:{
                en:'1 Queen bed',
                tc:'1張大床',
                sc:'1张大床',
            },
            des:{
                en:'Fixed window',
                tc:'固定窗戶',
                sc:'固定窗户',
            },
            img:['./images/rooms/row3_0.png','./images/rooms/row3_0.png'],
            view: {
                en:'harbour view',
                tc:'harbour view',
                sc:'harbour view',
            },
            amenities:{
                en:'Soap/Bathtub or Shower/Slippers Private Bathroom/Private Toilet/Hair Dryer/Bath Towel',
                tc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人廁所/吹風機/浴巾',
                sc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人厕所/吹风机/浴巾',
            },
            priceNum:990,
            bookingImg:'./images/rooms/row3_0.png',
    },
    superiorRoom:{
        title: {
            en:'Superior Room',
            tc:'高級客房',
            sc:'高级客房',
        },
        text:{
            en:'offer comfortable and convenient living spaces, blending home-like amenities with hotel services. Ideal for both short and long stays, they provide a cozy atmosphere.',
            tc:'提供舒適便利的居住空間，將居家般的便利與飯店服務融為一體。它們是短期和長期住宿的理想選擇，提供舒適的氛圍。',
            sc:'提供舒适便利的居住空间，将居家般的便利与饭店服务融为一体。它们是短期和长期住宿的理想选择，提供舒适的氛围。',
            
        },
        hoverText: {
            en:'offer comfortable and convenient living spaces, blending home-like amenities with hotel services. Ideal for both short and long stays, they provide a cozy atmosphere.',
            tc:'提供舒適便利的居住空間，將居家般的便利與飯店服務融為一體。它們是短期和長期住宿的理想選擇，提供舒適的氛圍。',
            sc:'提供舒适便利的居住空间，将居家般的便利与饭店服务融为一体。它们是短期和长期住宿的理想选择，提供舒适的氛围。',
        },
        capacity:{
            en:'1-2 person',
            tc:'1-2人',
            sc:'1-2人',
        },
        room:{
            en: '35㎡~ | Floor 12-20',
            tc: '35平方米~ | 層數 12-20',
            sc: '35平方米~ | 层数 12-20',
        },
        bed:{
            en:'1 Queen bed',
            tc:'1張大床',
            sc:'1张大床',
        },
        des:{
            en:'Fixed window',
            tc:'固定窗戶',
            sc:'固定窗户',

        },
        homeImg:'./images/home/sec3_1.jpg',
        img:['./images/rooms/row4_0.jpg','./images/rooms/row4_0.jpg'],
        view: {
            en:'harbour view',
            tc:'harbour view',
            sc:'harbour view',
        },
        amenities:{
            en:'Soap/Bathtub or Shower/Slippers Private Bathroom/Private Toilet/Hair Dryer/Bath Towel',
            tc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人廁所/吹風機/浴巾',
            sc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人厕所/吹风机/浴巾',
        },
        priceNum:799,
        bookingImg:'./images/rooms/row4_0.jpg',
    },
    standard:{
            title: {
                en:'Standard Room',
                tc:'標準客房',
                sc:'标准客房',
            },
            text:{
                en:'offer budget-friendly accommodations with essential amenities, providing a comfortable and independent living experience for travelers seeking simplicity and convenience during their stay.',
                tc:'提供配備基本設施的經濟實惠的住宿，為尋求簡單和便利的旅客提供舒適和獨立的生活體驗。',
                sc:'提供配备基本设施的经济实惠的住宿，为寻求简单和便利的旅客提供舒适和独立的生活体验。',
            },
            hoverText:{
                en:'offer budget-friendly accommodations with essential amenities, providing a comfortable and independent living experience for travelers seeking simplicity and convenience during their stay.',
                tc:'提供配備基本設施的經濟實惠的住宿，為尋求簡單和便利的旅客提供舒適和獨立的生活體驗。',
                sc:'提供配备基本设施的经济实惠的住宿，为寻求简单和便利的旅客提供舒适和独立的生活体验。',
            },
            capacity:{
                en:'1-2 person',
                tc:'1-2人',
                sc:'1-2人',
            },
            room:{
                en:'35㎡~ | Floor 6-11',
                tc:'35平方米~ | 層數 6-11',
                sc:'35平方米~ | 层数 6-11',
            },
            bed:{
                en:'1 Queen bed',
                tc:'1張大床',
                sc:'1张大床',
            },
            des:{
                en:'Fixed window',
                tc:'固定窗戶',
                sc:'固定窗户',
            },
            homeImg:'./images/home/sec3_0.png',
            img:['./images/rooms/row5_0.png','./images/rooms/row5_0.png'],
            view: {
                en:'harbour view',
                tc:'harbour view',
                sc:'harbour view',
            },
            amenities:{
                en:'Soap/Bathtub or Shower/Slippers Private Bathroom/Private Toilet/Hair Dryer/Bath Towel',
                tc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人廁所/吹風機/浴巾',
                sc:'肥皂/浴缸或淋浴/拖鞋私人浴室/私人厕所/吹风机/浴巾',
            },
            priceNum:990,
            bookingImg:'./images/rooms/row5_0.png',
    },
}
async function fetchRoomData(){
    try {
        const res = await fetchRooms();
        if (res.errno || !res.result.length) return;
        res.result.forEach(obj => {
            result[obj.key].title = obj.title;
            result[obj.key].priceNum = obj.price;
            result[obj.key].priceWeekend = obj.priceWeekend;
            result[obj.key]._id = obj._id
        });
        //console.log(res)
    } catch (error) {
        console.error("Error fetching room data:", error);
    }
}
fetchRoomData()
export default result